import React, { useEffect, useRef, useState } from 'react';

import SearchImg from '../../images/SideBar/Search';
import { CustomDropdownProps } from './props';

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  label,
  options,
  defaultOptionId,
  setDefaultOptionId,
  displayProperty,
  showStyle,
  value,
  style,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectOption = (optionId: string) => {
    setDefaultOptionId(optionId);
    setIsOpen(false);
  };

  const filteredOptions = options?.filter((option) =>
    option[displayProperty]?.toLowerCase()?.includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative w-full" ref={dropdownRef} style={{ width: '100%' }}>
      {label && <label className="text-fontBlack text-xs mb-2 ">{label}</label>}
      <button
        type="button"
        onClick={handleToggleDropdown}
        className={`relative ${style} w-full px-4 py-2 bg-white rounded-md shadow-md text-left text-fontColor font-medium focus:outline-none focus:ring-2 focus:ring-gray-400`}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <p className={`${showStyle}`}>
          {options.find((opt) => opt.id === defaultOptionId)?.[
            displayProperty
          ] || "Select option"}
        </p>
        {/* Arrow icon */}
        <svg
          className={`absolute flex items-center top-0 right-0 w-5 h-5 ${
            showStyle ? "mt-1" : "mt-3"
          } mr-3 transition-transform ${isOpen ? "transform rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          ></path>
        </svg>
      </button>
      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white rounded-md shadow-lg border p-1.5  border-gray-200 max-h-60 overflow-y-auto">
          {/* Search input */}
          <div className="flex items-center border  rounded-lg relative text-sm border-border text-fontColor">
            <div className="ml-2">
              <SearchImg />
            </div>
            <input
              ref={searchInputRef}
              type="search"
              className="w-full pl-3 py-1 rounded-md focus:outline-none bg-transparent"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* Options list */}
          <ul className="bg-white">
            {filteredOptions.map((option) => (
              <>
                <li
                  key={option.id}
                  className="px-4 py-2 hover:bg-gray-3 cursor-pointer  font-medium text-fontColor"
                  onClick={() => handleSelectOption(option.id)}
                >
                  {option[displayProperty]}
                </li>
              </>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
